import { pureSort as r } from "./arrayUtils.mjs";
import o from "../node_modules/date-fns/esm/fp/format/index.mjs";
import e from "../node_modules/date-fns/esm/addDays/index.mjs";
import m from "../node_modules/date-fns/esm/addMinutes/index.mjs";
import n from "../node_modules/date-fns/esm/getHours/index.mjs";
import i from "../node_modules/date-fns/esm/getMinutes/index.mjs";
import a from "../node_modules/date-fns/esm/compareAsc/index.mjs";
function s() {
  return {
    fra: /* @__PURE__ */ new Date(),
    tilOgMed: /* @__PURE__ */ new Date()
  };
}
o("HH:mm");
function d(t) {
  return [n(t), i(t)];
}
function u(t) {
  return r(t, a);
}
const f = "dd-MM-yyyy", p = /\d{2}-\d{2}-\d{4}/, w = {
  sortDates: u,
  addDays: e,
  addMinutes: m,
  newTimeperiod: s,
  getHourMinuteAsNumbersFromDate: d,
  danishFormat: f,
  danishFormatRegex: p
};
export {
  f as danishFormat,
  p as danishFormatRegex,
  w as default,
  d as getHourMinuteAsNumbersFromDate,
  s as newTimeperiod,
  u as sortDates
};
